import React, { useEffect } from 'react';

const PublishHtmlDoc = () => {
  useEffect(() => {
    // Load the HTML content
    const loadHtmlContent = async () => {
      try {
        const response = await fetch('/src/Pages/HtmlDoc/publishHtmlDoc.html');
        const htmlContent = await response.text();
        document.body.innerHTML = htmlContent;
      } catch (error) {
        console.error('Error loading HTML content:', error);
        document.body.innerHTML = '<div class="container"><h1>Error loading Publish HTML Document</h1></div>';
      }
    };

    loadHtmlContent();
  }, []);

  return <div id="publish-html-doc-container"></div>;
};

export default PublishHtmlDoc;
